import {useLocation} from "react-router-dom";
import {dispatchRequestStatus} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {useDispatchRequestMutation,} from "@ots-frontend/ots-ui";
import {DispatchRequestDispatchPage} from "../DispatchRequestDispatchPage/DispatchRequestDispatchPage";

type Props = {
  id?: string;
}

export const DispatchRequestAcceptFormPageRoute = () => {
  const {state} = useLocation();
  const id = state.id;
  return <DispatchRequestAcceptPage id={id}/>;
};

export const DispatchRequestAcceptPage = (props: Props) => {
  const {id} = props;

  const {t} = useTranslation(["translation"]);

  const {acceptDispatchRequest, isAccepting} = useDispatchRequestMutation();

  return (
    <DispatchRequestDispatchPage
      id={id}
      title={t<string>("page.dispatchrequest.accept.title", "Accept Dispatch Request")}
      expectedStatus={dispatchRequestStatus.pending}
      onSubmit={acceptDispatchRequest}
      isSubmitting={isAccepting}/>
  );
};
